<div class="join-community-popup" [class.active]="active" (click)="onClick($event)">
  <div class="jcp-win">
    <div class="jcp-close" (click)="close();">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.1665 4.16699L15.8332 15.8337" stroke="#9C877A" stroke-width="0.8" stroke-linecap="round"/>
        <path d="M4.1665 15.833L15.8332 4.16634" stroke="#9C877A" stroke-width="0.8" stroke-linecap="round"/>
      </svg>

    </div>

    <div class="jcp-content" *ngIf="!isSuccess">
      <div class="jcp-head">
        <h2>ПРИЄДНУЙСЯ ДО FOF СПІЛЬНОТИ</h2>
        <p>Щоб отримувати цікаві fashion-підбірки та завчасно дізнаватися про унікальні пропозиції.</p>
      </div>

      <div class="jcp-envelope">
        <img src="assets/images/envelope.png" alt="">
      </div>

      <div class="jcp-form">
        <div class="jcp-input-group">
          <input
            type="email"
            [(ngModel)]="email"
            placeholder="ТВІЙ EMAIL"
            [class.error]="emailError"
            [disabled]="isLoading">
          <div class="error-message" *ngIf="emailError">{{emailError}}</div>
        </div>

        <div class="error-message" *ngIf="errorMessage">{{errorMessage}}</div>

        <div class="jcp-btnwrap">
          <button
            class="jcp-button"
            (click)="subscribe()"
            [disabled]="isLoading">
            <span *ngIf="!isLoading">ПІДПИСАТИСЯ</span>
            <span *ngIf="isLoading">ЗАВАНТАЖЕННЯ...</span>
          </button>
        </div>

        <p class="jcp-agreement">
          Підписка означає згоду з
          <a
            [routerLink]="'/' + currentLang.slug + '/oferta'"
            target="_blank"
            rel="noopener"
            class="jcp-link"
            (click)="$event.stopPropagation()">політикою конфіденційності</a>
          та
          <a
            [routerLink]="'/' + currentLang.slug + '/oferta'"
            target="_blank"
            rel="noopener"
            class="jcp-link"
            (click)="$event.stopPropagation()">умовами використання</a>.
        </p>
      </div>
    </div>

    <div class="jcp-content jcp-success" *ngIf="isSuccess">
      <h2 class="jcp-success-title">Дякуємо!</h2>
      <p class="jcp-success-text">Email для підтвердження вже на пошті.</p>
      <p class="jcp-success-text">Залишилось перейти за посиланням у листі — і підписка активується.</p>
    </div>
  </div>
</div>
